import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { getDay, addDays } from 'date-fns';
import CoreDate from 'gatsby-theme-core/src/components/form-elements/date';
import Wrapper from './wrapper';
import Label from './label';

const filterDate = (excludeSaturdays, excludeSundays) => (date) => {
  const day = getDay(date);
  if (day === 0 && excludeSundays) {
    return false;
  }
  if (day === 6 && excludeSaturdays) {
    return false;
  }
  return true;
};

const highlightedClassName = 'react-datepicker__day--highlighted-limited';
const HighlightedLimitedStyles = createGlobalStyle`
  .${highlightedClassName}:not(.react-datepicker__day--disabled) {
    color: orange;
  }
`;

const DateComponent = ({
  className,
  name,
  label = null,
  placeholder = null,
  required = false,
  onChange,
  value,
  type = 'date',
  datepicker,
}) => (
  <Wrapper $singleColumn={!label}>
    {label && <Label required={required}>{label}</Label>}
    <HighlightedLimitedStyles />
    <CoreDate
      className={className}
      type={type === 'datetimeLocal' ? 'datetime-local' : type}
      name={name}
      placeholder={placeholder}
      required={required}
      onChange={onChange}
      value={value}
      useDatePicker={false}
      {...(!datepicker ? {} : {
        useDatePicker: true,
        minDate: datepicker.minDaysFromNow
          ? addDays(new Date(), datepicker.minDaysFromNow)
          : datepicker.min,
        maxDate: datepicker.max,
        excludeDates: datepicker.excludeDates?.map(({ date }) => new Date(date)),
        filterDate: filterDate(datepicker.excludeSaturdays, datepicker.excludeSundays),
        highlightDates: [{
          [highlightedClassName]: [...Array(datepicker.limitedDaysAfterMinDaysFromNow || 0)].map(
            (_, i) => addDays(new Date(), (datepicker.minDaysFromNow || 0) + i),
          ),
        }],
        children: datepicker.note,
      })}
    />
  </Wrapper>
);

export default styled(DateComponent)``;
